const KEYS = ["id", "annualRent", "effectiveFrom", "effectiveTo", "sourceCitation", "provenance"];
export function isRentDate(value) {
  return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
    && value >= "2000-01-01" && value <= "2100-12-31"
    && !Number.isNaN(Date.parse(`${value}T00:00:00Z`))
    && new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;
}

export function areaRentRatesError(rates) {
  if (!Array.isArray(rates) || rates.length > 100) return "rentRates must be an array of at most 100 dated rates";
  const ids = new Set();
  for (const rate of rates) {
    if (!rate || typeof rate !== "object" || Array.isArray(rate) || Object.keys(rate).some((key) => !KEYS.includes(key))) {
      return "Each rent rate must contain only id, annualRent, effectiveFrom, effectiveTo, sourceCitation and provenance";
    }
    if (rate.id != null && (typeof rate.id !== "string" || !rate.id.trim() || ids.has(rate.id))) return "Rent rate IDs must be unique nonempty strings";
    if (rate.id) ids.add(rate.id);
    if (rate.annualRent !== null && (typeof rate.annualRent !== "number" || !Number.isFinite(rate.annualRent)
      || rate.annualRent < 0 || rate.annualRent > 1000000000000)) return "annualRent must be a finite number from 0 to 1000000000000, or null";
    if (!isRentDate(rate.effectiveFrom) || !isRentDate(rate.effectiveTo) || rate.effectiveTo < rate.effectiveFrom) {
      return "Rent rates require valid effectiveFrom and effectiveTo dates in order (2000–2100)";
    }
    for (const key of ["sourceCitation", "provenance"]) {
      if (typeof rate[key] !== "string" || !rate[key].trim() || rate[key].length > 2000) return `${key} is required and must be at most 2000 characters`;
    }
  }
  const sorted = [...rates].sort((a, b) => a.effectiveFrom.localeCompare(b.effectiveFrom));
  if (sorted.some((rate, index) => index > 0 && rate.effectiveFrom <= sorted[index - 1].effectiveTo)) return "Rent rate segments must not overlap (end dates are inclusive)";
  return null;
}
